import { render, staticRenderFns } from "./PkRouteChannelInfoEdit.vue?vue&type=template&id=30c19dee&scoped=true&"
import script from "./PkRouteChannelInfoEdit.vue?vue&type=script&lang=js&"
export * from "./PkRouteChannelInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./PkRouteChannelInfoEdit.vue?vue&type=style&index=0&id=30c19dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c19dee",
  null
  
)

export default component.exports